import { useState } from 'react';
import styled from 'styled-components';
import { AutoComplete } from 'antd';
import { wavesAutocompleteHook } from '../../hooks/waves';
import { WaveStatusRenderer } from './common';
import { MuteText } from '../../elements';
import { useDebounce, useAutocompleteLoading } from '../../hooks';
import { AutocompleteSearchInput } from '../../components';

const OptionContainer = styled.div`
  padding: 8px 12px;
`;

const isValidWaveSearch = search => !!(search && typeof search === 'string');

function resultRenderer({ search, _id, status, waveNumber, metadata }) {
  const showResult = string => {
    try {
      const highlighted = string.replace(
        new RegExp(search, 'gi'),
        d => `<strong>${d}</strong>`,
      );

      return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
    } catch (error) {
      return string;
    }
  };

  return (
    <OptionContainer className="d-flex flex-column" key={_id}>
      <div className="d-flex justify-content-between align-items-center">
        <span>{showResult(waveNumber)}</span>
        <WaveStatusRenderer status={status} />
      </div>
      <div className="d-flex align-items-center">
        <div>
          <MuteText>Items:</MuteText>
          <span className="ml-1">{metadata.itemCount}</span>
        </div>
        <div className="ml-3">
          <MuteText>Starting Rack:</MuteText>
          <span className="ml-1">{metadata.startingRack?.code}</span>
        </div>
      </div>
    </OptionContainer>
  );
}

export function WaveSearchInput({
  top,
  onResultClick,
  inputClassName,
  setTableSearch = () => {},
  warehouseId,
  size,
}) {
  const [search, setSearch] = useState('');
  const [focused, setFocused] = useState(false);

  const finalSearch = useDebounce(search, 700);
  const { data, loading } = wavesAutocompleteHook(finalSearch, warehouseId);
  const isSearching = useAutocompleteLoading(search, finalSearch, loading);

  const options = (data ?? []).map(item => ({
    value: item._id,
    label: resultRenderer({ ...item, search }),
  }));

  return (
    <AutoComplete
      className={inputClassName}
      value={search}
      options={options}
      filterOption={false}
      open={focused && isValidWaveSearch(search)}
      placeholder="Wave Number"
      placement={top ? 'topLeft' : 'bottomLeft'}
      classNames={{ popup: { root: 'auto-search-dropdown' } }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onSearch={value => {
        setSearch(value);
        setTableSearch(value);
      }}
      onSelect={value => {
        const item = data.find(d => d._id === value);
        if (item?._id) {
          onResultClick(item);
          setSearch('');
        }
      }}
    >
      <AutocompleteSearchInput
        size={size}
        isSearching={isSearching}
        onClear={() => {
          setSearch('');
          setTableSearch('');
        }}
      />
    </AutoComplete>
  );
}
